import wishlist from './wishlist';
import details from './details';
import latestReleases from './latestReleases';
import courses from './courses';
import assessments from './assessments';

export default {
    wishlist, details, latestReleases, courses, assessments
}
